/** @format */

import {
  AppBar as MuiAppBar,
  Box,
  Toolbar,
  Container,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { MobileToolbar, DesktopToolbar } from '../Molecules/Toolbar';
import { drawerWidth } from './Sidebar/Sidebar';
import { useAppContext } from '../../store/store.app';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function MyAppbar() {
  const {
    appStore: { isDrawerOpen },
  } = useAppContext();
  const theme = useTheme();

  const appbarStyle = {
    backdropFilter: 'blur(8px) saturate(180%)',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(9, 9, 10, 0.75)'
        : 'rgba(14, 121, 184, 0.5)',
    boxShadow: 'none',
  };
  return (
    <AppBar
      className="no-print"
      position="fixed"
      sx={appbarStyle}
      open={isDrawerOpen}
    >
      <Container maxWidth={false} disableGutters>
        <Toolbar variant="dense" disableGutters>
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              alignItems: 'center',
            }}
          >
            <MobileToolbar />
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              flexGrow: 1,
              alignItems: 'center',
            }}
          >
            <DesktopToolbar />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default MyAppbar;
